import React, { ReactNode } from "react";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import StyledText from "./StyledText";
import { useTheme } from "../../middleware/ThemeContext";

interface StyledToolTipProps {
  children: ReactNode;
  title: string;
  placement?: "top" | "bottom" | "left" | "right";
  className?: string;
  childrenClass?: string;
  applyStyle?: boolean;
}

const StyledToolTip: React.FC<StyledToolTipProps> = ({
  children,
  title,
  placement,
  applyStyle = true,
}) => {
  const { theme } = useTheme();
  return (
    <Tippy content={<StyledText fontSize="12px" fontWeight={400} textColor={theme.CorporateTheme.colors.white}>{title}</StyledText>} placement={placement}>
      <span
        className={`${applyStyle ? "flex items-center cursor-pointer" : " "}`}
      >
        {children}
      </span>
    </Tippy>
  );
};

export default StyledToolTip;
